import {Lang} from 'yougile-lang'
import {UserEvent} from 'yougile-model'

export const getActionNameChangeRepeatTemplate = (event: UserEvent): string => {
  if (event.type !== 'repeat-template') {
    return ''
  }

  return Lang.msg.statsTimeline.statActionRepeatTemplateChanged
}
